import { RouteComponentProps } from 'react-router-dom';
import qs from 'query-string';
import { AppDispatch } from 'src/store';
import { IQueryParams } from 'src/types';
import { removeEmpty } from 'src/utils/removeEmpty';
import { createAction } from '@reduxjs/toolkit';

import { fetchPayoutLimitsRequest } from './requestHandlers';
import { IPayoutLimit } from './types';

const defaultParams = {
  page: '0',
  size: '10',
};

export const loadPayoutLimitsStart = createAction('payout_limits/load/start');

export const loadPayoutLimitsListSuccess = createAction<IPayoutLimit[]>('payout_limits/load/success');

export const loadPayoutLimitsRequest = (history: RouteComponentProps['history'], params: IQueryParams = {}, isInitialLoading?: boolean) => {
  return async (dispatch: AppDispatch): Promise<void> => {
    if (isInitialLoading) {
      dispatch(loadPayoutLimitsStart());
    }
    const initialParams = qs.parse(history.location.search);
    const mergedParams = { ...defaultParams, ...initialParams, ...removeEmpty(params) };
    const data = await fetchPayoutLimitsRequest();
    if (data) {
      dispatch(loadPayoutLimitsListSuccess(data));
      history.replace({
        search: qs.stringify(mergedParams, { skipNull: true }),
      });
    }
  };
};
